//@ts-nocheck

import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Text,
  Toast,
  useColorModeValue,
  useToast,
  VStack,
} from "@chakra-ui/react";
import axios from "axios";
import { useState } from "react";
import { useCookies } from "react-cookie";
import { socket } from "../../socket";
const UploadPayment = ({
  id,
  orderfile,
  onClose,
  userRole,
  deliveryproofupload,
}) => {
  const [file, setFile] = useState(null);
  const dropZoneBg = useColorModeValue("gray.100", "gray.700");
  const [cookies] = useCookies(["access_token"]);
  const Toast = useToast();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleFileDrop = (event) => {
    event.preventDefault();
    if (event.dataTransfer.files && event.dataTransfer.files[0]) {
      setFile(event.dataTransfer.files[0]);
    }
  };

  const triggerFileInput = () => {
    const fileInput = document.getElementById("file-input");
    fileInput && fileInput.click();
  };

  const ImageUploader = async (formData) => {
    console.log(formData);

    try {
      const res = await axios.post(
        "https://images.deepmart.shop/upload",
        formData
      );
      // console.log(res.data?.[0])
      return res.data?.[0];
    } catch (error) {
      console.error("Image upload failed:", error);
      return null;
    }
  };

  const handleFileUpload = async () => {
    if (!file) {
      alert("Please select a file to upload.");
      return;
    }
    let ImgURL = null;

    const formData = new FormData();
    formData.append("file", file);

    ImgURL = await ImageUploader(formData);

    
    const payload = {
      role: userRole,
      dispatcher_order_ss: ImgURL,
    };
    console.log(payload);

    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const token = cookies?.access_token;
      const response = await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}purchase/delivery/${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Toast({
        title: "Success",
        description: "File Uploaded Successfully :) ",
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      onClose(); // Close the modal or perform any other action
      socket.emit("notificationdatachange", true);
    } catch (error) {
      console.error("Error uploading file:", error);
      Toast({
        title: "Error",
        description: "Failed to upload the File :( ",
        status: "error",
        duration: 5000,
        isClosable: true,
      });

      onClose(); // Close the modal or perform any other action
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <VStack spacing={4} align="stretch">
        {orderfile ? (
          <Text fontSize="sm" color="teal.500">
            <strong className="text-black">
              {deliveryproofupload} have already sended the proof :{" "}
            </strong>
            <a href={orderfile} target="_blank">
              Uploaded File
            </a>
          </Text>
        ) : (
          <>
            <FormControl>
              <FormLabel>Upload Delivery Proof Screenshort</FormLabel>
              <Box
                p={4}
                borderWidth="2px"
                borderColor={file ? "teal.500" : "gray.300"}
                borderRadius="md"
                bg={dropZoneBg}
                textAlign="center"
                onDrop={handleFileDrop}
                onDragOver={(event) => event.preventDefault()}
                onDragEnter={(event) => event.preventDefault()}
                onClick={triggerFileInput}
                cursor="pointer"
              >
                <Text fontSize="sm" color="gray.500">
                  Drag and drop a file here, or{" "}
                  <Text as="span" color="blue.500" cursor="pointer">
                    browse
                  </Text>
                </Text>
              </Box>
              <Input
                type="file"
                id="file-input"
                display="none"
                onChange={(event) =>
                  setFile(event.target.files ? event.target.files[0] : null)
                }
              />
            </FormControl>

            <Button
              colorScheme="blue"
              mr={3}
              onClick={handleFileUpload}
              isDisabled={!file}
              disabled={isSubmitting}
            >
              Upload
            </Button>
          </>
        )}
      </VStack>
    </div>
  );
};

export default UploadPayment;
